export const defaultAvatar = new URL('@tabeeb/assets/images/unknown.png', import.meta.url)

export const TenantAuthErrorTypes = {
  ForbiddenTenant: 'ForbiddenTenant',
  ProfileDisabled: 'ProfileDisabled',
  TenantRequiresMfa: 'TenantRequiresMfa',
  AccountNotCreated: 'AccountNotCreated',
  UnacceptableRole: 'UnacceptableRole',
  TenantRequiresSso: 'TenantRequiresSso',
  SsoProviderNotAllowed: 'SsoProviderNotAllowed',
}

export const TenantAuthErrorMessages = {
  AccessRestricted: 'Access to the tenant has been restricted',
  AccountDisabled: 'Your account has been disabled',
  RequiresSso: 'Access to the tenant is available only via SSO login',
  InvalidSso: 'Used SSO provider is not allowed for this tenant',
}
